module.exports = __webpack_public_path__ + "img/zhanye@2x.34be59ff.png";